/**
 * Every route becomes a chunk, loaded only when used.
 * Reduces size of initial App load.
 */
const routes = [
	{
		name: 'Bounce',
		path: '/',
		component: () => import('@/views/Bounce.vue'),
		title: 'Bounce'
	},
	{
		name: 'Meeting',
		path: '/meeting/:id',
		component: () => import('@/views/Meeting.vue'),
		title: 'Meeting'
	},
	{
		name: 'Blocked',
		path: '/blocked/:id',
		component: () => import('@/views/Blocked.vue'),
		title: 'Blocked'
	},
	{
		name: 'NoMeeting',
		path: '/no-meeting/:id',
		component: () => import('@/views/NoMeeting.vue'),
		title: 'No Meeting'
	},
	{
		name: 'Session',
		path: '/session/:id',
		component: () => import('@/views/Session.vue'),
		title: 'Session'
	},
	{
		name: 'Transport',
		path: '/transport/:id',
		component: () => import('@/views/Transport.vue'),
		title: 'Transport'
	},
	{
		name: 'Welcome',
		path: '/welcome/:id',
		component: () => import('@/views/Welcome.vue'),
		title: 'Welcome'
	}
];

export default routes;
